// src/plugins/globalComponents.js
export default {
    install(app) {
        // 第三个参数为正则，匹配 .vue 组件；第二个参数 false 表示不递归子目录
        const ctx = require.context('@/components', false, /\.vue$/)

        ctx.keys().forEach((key) => {
            const comp = ctx(key).default
            const name =
                comp.name || key.replace(/^.*[\\/]/, '').replace(/\.vue$/, '')
            app.component(name, comp)
        })
    }
}
